// Single source of truth for auction-type display labels AND their display
// order, previously hardcoded independently as the same 4-way ternary in
// AuctionManagement.js (create form, edit-mode badge, edit budget heading)
// and AdminOverview.js's summary table.
export const AUCTION_TYPE_CONFIG = {
  // Active types — the only ones offered in the Create Event UI, in the
  // fixed order AuctionManagement.js's Event Type picker displays them.
  grants_fixed: { label: 'Grants - Fixed Rates', order: 1 },
  grants_contribution: { label: 'Grants - % Contribution', order: 2 },
  competitive_pay_as_bid: { label: 'Competitive (Reverse-auction)', order: 3 },
  competitive_fundspreader: { label: 'Competitive (Fundshare)', order: 4 },
  manual: { label: 'Manual (EOIs and Innovation)', order: 5 },

  // Legacy types — retained only so already-existing auctions still display
  // a correct label; no longer selectable when creating a new auction.
  algorithmic: { label: 'Algorithmic (Legacy)', order: null },
  unified_vfm: { label: 'Unified VfM (Legacy)', order: null },
  grants: { label: 'Fixed-Rate Grants (Legacy)', order: null },
};

// The 5 active types, in Event Type picker order.
export const ACTIVE_AUCTION_TYPES = Object.keys(AUCTION_TYPE_CONFIG)
  .filter(t => AUCTION_TYPE_CONFIG[t].order !== null)
  .sort((a, b) => AUCTION_TYPE_CONFIG[a].order - AUCTION_TYPE_CONFIG[b].order);

export function getAuctionTypeLabel(auctionType) {
  return AUCTION_TYPE_CONFIG[auctionType]?.label || 'Unified VfM';
}
